export default __webpack_public_path__ + "static/ben-3-c75bacb6dc7bad4648b63432a9083902.png";